import { error, log } from '@/services/Log'
import type { ApplePayHandlerBuilderInput } from '../types'

export const handleSessionCancelled = ({
  beforeFinalize,
}: ApplePayHandlerBuilderInput) => async (
  event: ApplePayJS.Event,
) => {
  log('Apple Pay Session Cancelled ', event)
  if (beforeFinalize) {
    try {
      await beforeFinalize()
    } catch (err) {
      error('Error executing beforeFinalize session', err)
    }
  }
}

export default handleSessionCancelled
